module.exports = __webpack_public_path__ + "media/corporate-image/top-image-bb12c17eaf620ed537adc0fa4820b57d.jpg";